export default __webpack_public_path__ + "static/media/Linkedin-Curious.9cec2c3a.png";